/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {timecardOvertimeSegments} from '../api'

export const useMutationTimecardOvertimeSegments = createReactQueryMutationHook('timecardOvertimeSegments', timecardOvertimeSegments)
